import { gql } from 'apollo-angular';

export const GET_MY_ROLE_OPEN_TASKS_QUERY = gql`
  query MyOpenTasks {
    myOpenTasks {
      actionTaken
      assigneeUserId
      businessKey
      businessType
      comment
      completedAt
      createdAt
      id
      instanceId
      stageCode
      stageName
      status
      taskData
    }
  }
`;
